export default "__VITE_ASSET__BcPT7FTn__"